import { auth } from '../config/firebase';

// Read API base URL from environment variable set in package.json scripts
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_BASE_URL is not set. Check package.json scripts.');
}

console.log('Using API Base URL:', API_BASE_URL);

// Helper function to get Firebase auth token
const getAuthToken = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  return await user.getIdToken();
};

// New API for survey takers
export const surveyAPI = {
  // Start the survey session
  startSession: async (accessToken, language = 'en') => {
    console.log('Starting survey session...');

    const token = await getAuthToken(); // This will be the anonymous auth token

    const response = await fetch(`${API_BASE_URL}/survey/sessions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ access_token: accessToken, language }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to start survey session: ${errorText}`);
    }

    return response.json();
  },

  // Send a survey message
  sendMessage: async (sessionId, message) => {
    console.log('Sending survey message to:', `${API_BASE_URL}/survey/chat`);

    const token = await getAuthToken();

    const response = await fetch(`${API_BASE_URL}/survey/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ sessionId, message }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error('Failed to send survey message');
    }

    return response.json();
  },
};

export const chatAPI = {
  // Create a new session
  createSession: async (userId) => {
    console.log('Creating session for userId:', userId);

    const token = await getAuthToken();

    const response = await fetch(`${API_BASE_URL}/sessions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ userId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to create session: ${errorText}`);
    }

    return response.json();
  },

  // Send a message
  sendMessage: async (sessionId, message) => {
    console.log('Sending message to:', `${API_BASE_URL}/chat`);
    console.log('Payload:', { sessionId, message });

    const token = await getAuthToken();

    const response = await fetch(`${API_BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ sessionId, message }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error('Failed to send message');
    }

    return response.json();
  },

  // Get all sessions
  getSessions: async () => {
    const token = await getAuthToken();

    const response = await fetch(`${API_BASE_URL}/sessions`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to get sessions');
    }

    return response.json();
  },

  // Get session history
  getSessionHistory: async (sessionId) => {
    const token = await getAuthToken();

    const response = await fetch(`${API_BASE_URL}/sessions/${sessionId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to get session history');
    }

    return response.json();
  },
};
